:host{display:flex;width:100%}
/*# sourceMappingURL=sub-accounts.component-66NYGD6S.css.map */
